// extracted by mini-css-extract-plugin
export default {"label":"ShowMore_label__r-QZi"};